export default __webpack_public_path__ + "static/media/awar3.2793bd02.jpg";